import { render, staticRenderFns } from "./TopSpender.vue?vue&type=template&id=7ecd19ab&scoped=true"
import script from "./TopSpender.vue?vue&type=script&lang=js"
export * from "./TopSpender.vue?vue&type=script&lang=js"
import style0 from "./TopSpender.vue?vue&type=style&index=0&id=7ecd19ab&prod&scoped=true&lang=css"
import style1 from "./TopSpender.vue?vue&type=style&index=1&id=7ecd19ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd19ab",
  null
  
)

export default component.exports